import { SearchSnippets } from '@logz-pkg/enums';
export class SearchSnippet {
    constructor(props) {
        Object.assign(this, props);
    }
    snippetId = SearchSnippets.LogzioFilterSearchSnippet;
    name = 'Untitled';
    type = 'logs';
    value;
}
//# sourceMappingURL=search-snippets.js.map